import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ButtonComponent } from '@atoms/button/button.component';
import { LinkButtonComponent } from '@atoms/link-button/link-button.component';
import { environment } from '@env/environment';
import { AnalyticsPreferencesModalComponent } from '@organisms/analytics-preferences-modal/analytics-preferences-modal.component';
import { ConsentService } from '@services/consent.service';
import { PosthogService } from '@services/posthog.service';
import { POSTHOG_EVENTS } from '@services/posthog-events';

@Component({
  selector: 'iahoy-analytics-consent-banner',
  imports: [ButtonComponent, LinkButtonComponent],
  templateUrl: './analytics-consent-banner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './analytics-consent-banner.component.scss'
})
export class AnalyticsConsentBannerComponent {
  private readonly dialog = inject(MatDialog);
  private readonly consentService = inject(ConsentService);
  private readonly posthogService = inject(PosthogService);

  readonly shouldShowBanner = this.consentService.shouldShowBanner;
  readonly cookiePolicyUrl = new URL('/cookie-policy/', environment.landingUrl).toString();

  openPreferences(): void {
    this.dialog.open(AnalyticsPreferencesModalComponent, {
      width: '622px',
      panelClass: 'dialog-panel'
    });
  }

  acceptAnalytics(): void {
    this.consentService.acceptAnalytics();
    void this.posthogService.capture(POSTHOG_EVENTS.analyticsConsentUpdated, {
      source: 'banner',
      analytics_enabled: true
    });
  }

  rejectAnalytics(): void {
    this.consentService.rejectAnalytics();
  }
}
